import { useTranslation } from "next-i18next";
import Image from "@/components/Atoms/Image";
import { MultiPurposeParagraph } from "@/components/Atoms/Paragraph";
import { ButtonMaster } from "@/components/Atoms/Buttons";
import {
	resolveButtonCustomIcon,
	resolveButtonIconColor,
} from "@/lib/functions";
import styles from "@/components/Organisms/Product/ProductRange/index.module.scss";

type LimitedEditionRelatedCardProps = {
	entry: {
		brandName?: string;
		productName?: string;
		factSheetImage?: unknown;
		href?: string;
		hideCallToAction?: boolean;
	};
	textColor?: { hex?: string; cssRgb?: string };
	buttonConfig?: any;
	variant?: "default" | "carousel";
};

export function LimitedEditionRelatedCard({
	entry,
	textColor,
	buttonConfig,
	variant = "default",
}: LimitedEditionRelatedCardProps) {
	const { t } = useTranslation();

	const imageClassName =
		variant === "carousel" ? "z-30 mx-auto" : "max-w-[12rem] md:max-w-[16rem] z-30 mx-auto w-full";

	return (
		<div className="flex w-full flex-col items-center">
			<div
				className={
					variant === "carousel"
						? styles.galleryCarouselProductImageWrap
						: "flex w-full justify-center"
				}
			>
				<Image
					className={imageClassName}
					objectFit={variant === "carousel" ? "contain" : undefined}
					data={entry?.factSheetImage}
				/>
			</div>
			<article className="flex w-full flex-col items-center gap-6 pt-4">
				<div
					className={`${styles.title} ${
						variant === "carousel" ? styles.titleCarousel : ""
					} flex w-full flex-col items-center gap-2 text-center`}
				>
					{entry.brandName && (
						<MultiPurposeParagraph
							type="showcaseLabel"
							align="center"
							data={entry.brandName}
							color={textColor}
						/>
					)}
					{entry.productName && (
						<MultiPurposeParagraph
							type="showcaseProductName"
							align="center"
							data={entry.productName}
							color={textColor}
						/>
					)}
				</div>
				{!entry.hideCallToAction && entry.href && (
					<ButtonMaster
						anim="slideLeft"
						type={buttonConfig?.buttonStyle ?? "bgFillSquare"}
						color={
							buttonConfig?.labelColor?.color ?? { hex: "#ffffff" }
						}
						cta={buttonConfig?.typeColor?.color ?? textColor}
						customIcon={resolveButtonCustomIcon(buttonConfig)}
						customColor={resolveButtonIconColor(buttonConfig)}
						link={entry.href}
					>
						{t("seeMore")}
					</ButtonMaster>
				)}
			</article>
		</div>
	);
}
